"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionGroupCreator = void 0;
var firestore_1 = require("firebase/firestore");
var collectionGroupCreator = function (fStore, collectionID) {
    return function (firestore) {
        return (0, firestore_1.collectionGroup)(
        // @ts-expect-error
        firestore || fStore, // ! type messed up, after adding firestore of testing type, weird
        collectionID);
    };
};
exports.collectionGroupCreator = collectionGroupCreator;
